const asset = (name) => `${window.location.origin}/assets/themes/${name}`;

const demoImages = {
  woman: "demo-fashion-woman.webp",
  man: "demo-fashion-man.webp",
  bag: "demo-leather-bag.webp",
  decor: "demo-home-decor.webp",
  headphones: "demo-headphones.webp",
  laptop: "demo-laptop.webp",
  chair: "demo-chair.webp",
  candle: "demo-candle.webp",
};

const item = (id, name, image, price, category) => ({
  id,
  name,
  slug: name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, ""),
  image: asset(demoImages[image]),
  product_image: [{ image: asset(demoImages[image]) }],
  productprices: { seeling_price: price, original_price: price },
  pricing: { final_price: price, original_price: price, has_discount: false },
  featured: 1,
  popular: 1,
  category_id: category.id,
  category,
});

export function buildThemeDemoCatalog(themeKey) {
  const renown = themeKey === "prestige";
  const tech = themeKey === "electronics";
  const definitions = renown
    ? [
        [1, "Women", "woman"], [2, "Men", "man"], [3, "Accessories", "bag"], [4, "Living", "decor"],
      ]
    : tech
      ? [
          [1, "Audio", "headphones"], [2, "Computing", "laptop"], [3, "Home office", "chair"], [4, "Lifestyle", "candle"],
        ]
      : [
          [1, "Home", "chair"], [2, "Lifestyle", "candle"], [3, "Technology", "headphones"], [4, "Accessories", "bag"],
        ];

  const categories = definitions.map(([id, name, image]) => ({
    id,
    name,
    slug: name.toLowerCase().replace(/\s+/g, "-"),
    image: asset(demoImages[image]),
  }));

  const products = renown
    ? [
        item(101, "The Camel Blazer", "woman", 18900, categories[0]),
        item(102, "Textured Knit", "man", 12400, categories[1]),
        item(103, "Structured Leather Tote", "bag", 15800, categories[2]),
        item(104, "Sculptural Vessel", "decor", 7600, categories[3]),
        item(105, "Tailored Essential", "woman", 17400, categories[0]),
        item(106, "Charcoal Layers", "man", 11800, categories[1]),
        item(107, "Everyday Carry", "bag", 14900, categories[2]),
        item(108, "Olive Arrangement", "decor", 6900, categories[3]),
      ]
    : tech
      ? [
          item(201, "Studio Headphones", "headphones", 24900, categories[0]),
          item(202, "Slim Performance Laptop", "laptop", 189000, categories[1]),
          item(203, "Focus Lounge Chair", "chair", 68500, categories[2]),
          item(204, "Ambient Desk Candle", "candle", 4200, categories[3]),
          item(205, "Wireless Headphones", "headphones", 21900, categories[0]),
          item(206, "Everyday Notebook", "laptop", 154000, categories[1]),
          item(207, "Workspace Chair", "chair", 59000, categories[2]),
          item(208, "Calm Workspace Scent", "candle", 3900, categories[3]),
        ]
      : [
          item(301, "Boucle Lounge Chair", "chair", 68500, categories[0]),
          item(302, "Linen Candle", "candle", 4200, categories[1]),
          item(303, "Wireless Headphones", "headphones", 21900, categories[2]),
          item(304, "Leather Carryall", "bag", 14900, categories[3]),
          item(305, "Stoneware Arrangement", "decor", 6900, categories[0]),
          item(306, "Slim Notebook", "laptop", 154000, categories[2]),
          item(307, "Textured Knit", "man", 11800, categories[1]),
          item(308, "Tailored Essential", "woman", 17400, categories[3]),
        ];

  return { categories, products };
}

export function prepareThemeForDemo(theme, themeKey) {
  const heroImage = asset("prestige-hero-v2.webp");

  return {
    ...theme,
    sections: (theme.sections || []).map((section) => {
      const settings = { ...(section.settings || {}) };
      if (section.type === "hero_banner") {
        // The demo photo only fills an empty image. An image the merchant chose always shows.
        const fill = (item) => ({
          ...item,
          imageUrl: item.imageUrl || heroImage,
          mobileImageUrl: item.mobileImageUrl || item.imageUrl || heroImage,
        });
        const slides = Array.isArray(settings.slides) && settings.slides.length
          ? settings.slides.map(fill)
          : undefined;
        const prestigeHero = themeKey === "prestige" && ["Worn with intention", "Quiet luxury"].includes(settings.title)
          ? { badge: "New season 2026", title: "Elevate Your Everyday Style", subtitle: "Discover modern essentials curated with premium craftsmanship and timeless silhouettes.", ctaText: "Shop collection", alignment: "left" }
          : {};
        return {
          ...section,
          settings: {
            ...fill(settings),
            ...prestigeHero,
            ...(slides ? { slides } : {}),
          },
        };
      }
      if (themeKey === "prestige" && section.type === "collection_list" && Number(settings.columns || 3) === 3) {
        return { ...section, settings: { ...settings, layout: "grid-4", columns: 4, categoryCount: 4 } };
      }
      if (themeKey === "prestige" && section.type === "featured_products" && Number(settings.columns || 3) === 3) {
        return { ...section, settings: { ...settings, columns: 4, count: 8 } };
      }
      if (section.type === "image_with_text" && !settings.imageUrl) {
        return { ...section, settings: { ...settings, imageUrl: asset("demo-home-decor.webp") } };
      }
      return section;
    }),
  };
}
